import React from "react";
import { Box, Skeleton } from "@mui/material";
import "../assets/css/fullLoader.css";

export const Loader = (img = "validacion-loader.gif") => {
  return (
    <div style={{ zIndex: 99999999999999999999999999999999999999999999999999 }}>
      <div id="preloader2" className="text-center">
        <img src={`../assets/img/${img}`} className="img-fluid" alt=""></img>
      </div>
    </div>
  );
};

export const LoadingGraphs = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        p: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Título simulado */}
      {/* <Typography variant="subtitle2" sx={{ mb: 1 }}>
        <Skeleton width="50%" />
      </Typography> */}

      {/* Área de la “gráfica” */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: 1,
          height: "100%",
        }}
      >
        {[40, 60, 80, 55, 70, 90, 50].map((height, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="10%"
            height={`${height}%`}
            sx={{
              borderRadius: 1,
              animationDuration: "1.5s",
            }}
          />
        ))}
      </Box>

      {/* Eje X simulado */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 1,
        }}
      >
        {[...Array(7)].map((_, i) => (
          <Skeleton key={i} variant="text" width="10%" height={10} />
        ))}
      </Box>
    </Box>
  );
};
